module.exports = __webpack_public_path__ + "img/Saude_e_Meio_Ambiente.b662d59f.jpg";